import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.11);
  position: relative;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead`
  width: 100%;
`;

export const TableBody = styled.tbody`
  width: 100%;
`;

export const TableFooter = styled.tfoot`
  width: 100%;
`;
